import React, { Fragment, useEffect, useRef } from 'react';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {
    Paper, Grid, FormControl, InputLabel,
    Select, MenuItem, TextField, Icon, Typography
} from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import { masterData } from "./data";
import moment from 'moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import errormesages from './errormessages';
export default function EirInstallationAddress(props) {
    const { errors, control } = useFormContext();
    const { validation } = errormesages;
    const classes = useStyle();
    const addressInputRef = useRef();
    const prefInstallationTimeInputRef = useRef();
    const prefInstallationDateInputRef = useRef();
    
 const d = new Date();
 let day = d.getDay();
 
 function addEighten(){
    return new Date().setDate((new Date()).getDate() + 18)
  }
  function addSixteen(){
    return new Date().setDate((new Date()).getDate() + 16)
  }

    return (
        <Fragment>
            <Grid item sm={12} className={classes.personalPadding}>
                <Paper className={classes.contactPaper} variant='elevation' elevation={4}>
                    <Grid container>
                        <Grid item sm={12}>
                            <h2 className={classes.contactTxt}>
                                Installation appointment
                            </h2>
                        </Grid>
                        {props.showTechInstallationMsg ?
                            <Grid item sm={12} xs={12} className={classes.installationMsgArea}>
                                <Typography className={classes.installationMsg}>{props.showTechInstallationMsg}</Typography>
                            </Grid>
                            : ''}
                        <Grid container sm={12}>
                            {props.prequalAddres ?
                                <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
                                    <TextField inputRef={addressInputRef} color="secondary"
                                        id="installAddress"
                                        name="installAddress"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        value={props.prequalAddres}
                                        style={{ whiteSpace: 'pre-wrap' }}
                                    />
                                </Grid>
                                : ''}

                            {props.hasInstallationFee ?
                                <Grid item sm={6} xs={12} >
                                    <Grid sm={12} className={props.prequalAddres ? classes.paddingLeftCalender : ''}>
                                        <MuiPickersUtilsProvider
                                            utils={MomentUtils}
                                            moment={moment}
                                        >
                                            <Fragment>
                                                <Controller
                                                    as={<KeyboardDatePicker inputProps={{ readOnly: true, }} />}
                                                    defaultValue={null}
                                                    required
                                                    fullWidth
                                                    inputVariant='outlined'
                                                    format='DD/MM/YYYY'
                                                    autoOk
                                                    id='prefDate'
                                                    name='prefDate'
                                                    label='Preferred installation date'
                                                    variant='outlined'
                                                    size='small'
                                                  minDate={(new Date()).setDate((new Date()).getDate() + 7)} 
                                                //  minDate={ day===5? addEighten() : addSixteen()}  
                                                    shouldDisableDate={(x)=> ([0,6].includes(new Date(x).getDay()))}
                                                    keyboardIcon={
                                                        <Icon className={classes.calenderIcon}></Icon>
                                                    }
                                                    inputRef={prefInstallationDateInputRef}
                                                    control={control}
                                                    rules={{ required: { value: true, message: validation.prefInstallationDateRequired } }}
                                                    error={Boolean(errors.prefInstallationTime)}
                                                    onFocus={() => {
                                                        prefInstallationDateInputRef.current.focus();
                                                    }}
                                                />
                                                <Grid className={classes.errorMessageHeightCalender}>
                                                    <ErrorMessage errors={errors} name='prefDate'>
                                                        {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                                    </ErrorMessage>
                                                </Grid>
                                            </Fragment>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item sm={12} className={props.prequalAddres ? classes.paddingLeftItem : ''}>
                                        <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                            <InputLabel required
                                            >Preferred Installation Time</InputLabel>
                                            <Controller
                                                control={control}
                                                name="prefInstallationTime"
                                                id="prefInstallationTime"
                                                inputRef={prefInstallationTimeInputRef}
                                                defaultValue=""
                                                rules={{ required: { value: true, message: validation.prefInstallationTimeRequired } }}
                                                error={Boolean(errors.prefInstallationTime)}
                                                onFocus={() => {
                                                    prefInstallationTimeInputRef.current.focus();
                                                }}
                                                as={
                                                    <Select
                                                        id='prefInstallationTime'
                                                        label="Preferred Installation Time"
                                                    >
                                                        {masterData.filter(masterData => masterData.id === 'installationTime').map((data) =>
                                                            data.value.map((val) =>
                                                            (
                                                                <MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
                                                                    {val.label}
                                                                </MenuItem>
                                                            ))
                                                        )}
                                                    </Select>
                                                }
                                            />
                                            <Grid className={classes.errorMessageHeight}>
                                                <ErrorMessage errors={errors} name='prefInstallationTime'>
                                                    {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                                </ErrorMessage>
                                            </Grid>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                : ''}
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Fragment>
    );
}